interface AnswerResponse {
    inputLabel?: string;
    inputType?: string;
    inputValue?: string;
    tag?: string;
}

interface Response {
    _id?: string;
    selfieID?: string;
    questionType: string;
    answerResponse: AnswerResponse[];
}

const getSelfieId = (responses: Response[]) => {
    for (const { questionType, selfieID } of responses) {
        if (questionType === "selfie" && selfieID) {
            return selfieID;
        }
    }
    return "";
}

export const getFormData = (responses: Response[]) => {
    return responses.reduce((formData, response) => {
        const { questionType, answerResponse, _id } = response;
        if (questionType === "email") {
            formData["email"] = answerResponse[0]?.inputValue
        }
        if (questionType === "input" && answerResponse.length > 0 && _id) {
            answerResponse.forEach((response) => {
                const keyName = response.tag ? response.tag : `${response.inputLabel.replace(/\s/g, "")}_${_id}`;
                formData[keyName] = response?.inputValue || "";
            });
        }

        return formData;
    }, {} as { [key: string]: string });
}

export const extractTags = (responses: Response[]) => {
    return responses
        .map(({ questionType, answerResponse }) => {
            if (["single", "multi", "input"].includes(questionType)) {
                return answerResponse.map((response) => {
                    if (response.tag) {
                        return response.tag.split(',');
                    }
                    return [];
                }).flat();
            }
            return [];
        })
        .flat();
}

const constructQuizResponse = (responses: Response[], formId: string, shopId: string, quiz: object) => {
    return {
        form_id: formId,
        shop_id: shopId,
        responses: {
            id: getSelfieId(responses),
            app_version: `/quiz_inline/v${import.meta.env.VITE_RELEASE_VERSION}`,
            parent_cookies: document.cookie,
            parent_referrer: document.referrer,
            parent_url: window.location.href,
            selfie_user: "mango",
            form: getFormData(responses),
            tags: [...extractTags(responses), "tangent_quiz"],
            raw_response: responses,
            other_data: {
                redirection_url: quiz?.meta?.recoUrl
            },
        }
    };
}

export default constructQuizResponse;